// extracted by mini-css-extract-plugin
export default {"AutomationDescription":"AutomationDescription_AutomationDescription__jtmlz"};